import React from 'react'
import { Keyboard, StyleSheet, Switch, Text, View, ViewStyle } from 'react-native'
import { colors } from '@lib/colors'
interface ToggleProps {
  label: string
  toggled: boolean
  onValueChange: () => void
}

const Toggle = (props: ToggleProps) => {
  const { label, toggled, onValueChange } = props

  const onToggle = () => {
    onValueChange()
    Keyboard.dismiss()
  }

  return (
    <View style={styles.toggleWrapper}>
      <Switch
        trackColor={{ false: colors.gray['300'], true: colors.green['50'] }}
        thumbColor={toggled ? colors.green['400'] : colors.gray['100']}
        ios_backgroundColor={colors.gray['100']}
        onValueChange={onToggle}
        value={toggled}/>
      <Text style={styles.toggleText}>{label}</Text>
    </View>
  )
}

export default Toggle

interface Styles {
  toggleWrapper: ViewStyle,
  toggleText: ViewStyle
}

const styles = StyleSheet.create<Styles>({
  toggleWrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 15,
  },
  toggleText: {
    color: colors.gray['900'],
    marginLeft: 10,
  },
})
